import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { NavLink, Redirect } from 'react-router-dom';
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, Contesto, Bottone, CampoNumero } from '../components/';

interface IFideCoobbligatoState {
    Dati: DatiFide.CRisAPILista_FideCoobbligato;
}

export class FideCoobbligato extends BaseComponent<Glob.IRouteGlobaleProps, IFideCoobbligatoState> {

    private ID_FideAffidamento?: number = undefined;
    private ID_Polizza?: number = undefined;

    constructor(props: any) {
        super(props);
        this.state = { Dati: new DatiFide.CRisAPILista_FideCoobbligato() };
        this.ID_Polizza = (this.props.match.params as any).ID_Polizza;
        if (this.ID_Polizza == undefined) { //Se non è stata specificata la polizza allora si tratta della lista dei coobbligati per l'affidamento
            this.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento;
        }
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPILista_FideCoobbligato, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Dati: dati });
        }

        return dati.RisAPI.Dati.map((dato, indice) => <tr data-row="0" key={indice}>
            <td data-field="Anag" className="TextLeft">
                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo={"RisAPI.Dati." + indice + ".ID_Anag"} ID_ChiaveString={dato.ID_Anag.toString() || "0"} OnAggiorna={this.OnChange} TradValori LinkSelezione="/anagrafica/" />
            </td>
            <td data-field="AnagAggiungi" className="TextLeft" style={{ width: 0 }}>
                <a href="/anagrafica/0" onClick={(e) => { e.preventDefault(); this.ApriPopupCoobbligato(indice) }} className="arrow"> <i className="fa fa-plus" /> </a>
            </td>
            <td data-field="Quota">
                <div className="kt-input-icon kt-input-icon--right">
                    <CampoNumero CSS="form-control kt-input TextRight" Id={"RisAPI.Dati." + indice + ".Quota"} Name={"RisAPI.Dati." + indice + ".Quota"} OnChange={(e) => { this.OnChange(e) }} Valore={dato.Quota} Icona="fa fa-percentage" />
                </div>
            </td>
            <td data-field="Importo">
                <div className="kt-input-icon kt-input-icon--right">
                    <CampoNumero CSS="form-control kt-input TextRight" Id="Importo" Name="Importo" OnChange={(e) => { this.OnModificaImporto(indice, (e as React.FormEvent<any>)) }} Valore={(dato.Quota * dati.Extra.Importo) / 100} Icona="fa fa-euro-sign" />
                </div>
            </td>
            <td className="TextCenter">
                <Bottone Testo={Trad.Trad("Elimina")} Dato={indice} OnClick={(s) => this.OnEliminaCoobbligato(s)} ClasseAttivo="btn btn-danger" />
            </td>
        </tr>);
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        Glob.InfoModaleSuccess(Trad.Trad("Coobbligati"), Trad.TradParam("Operazione avvenuta correttamente", [this.ID_FideAffidamento]));
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPILista<DatiFide.CDatiFideCoobbligato>();
        if (this.state.Dati.RisAPI.Dati.length > 0) {
            Ingr.Dati = this.state.Dati.RisAPI.Dati;
        }
        else {
            let FC = new DatiFide.CDatiFideCoobbligato();
            FC.ID_FideAffidamento = this.ID_FideAffidamento;
            FC.ID_Polizza = this.ID_Polizza;
            FC.Quota = -1;
            Ingr.Dati = [];
            Ingr.Dati.push(FC)
        }
        return Ingr;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnNuovoCoobbligato(): void {
        for (let FC in this.state.Dati.RisAPI.Dati) {
            if (this.state.Dati.RisAPI.Dati[FC].ID_Anag == 0) {
                return;
            }
        }
        let FC = new DatiFide.CDatiFideCoobbligato();
        FC.ID_FideAffidamento = this.ID_FideAffidamento;
        FC.ID_Polizza = this.ID_Polizza;
        this.state.Dati.RisAPI.Dati.push(FC)
        this.setState({ Dati: this.state.Dati });
    }

    private OnModificaImporto(indice: number, e: React.FormEvent<any>): void {
        if (this.state.Dati.Extra.Importo != 0) {
            let V = e.currentTarget.value;
            this.state.Dati.RisAPI.Dati[indice].Quota = (V / this.state.Dati.Extra.Importo) * 100;
            this.setState({ Dati: this.state.Dati });
        }
    }

    private OnEliminaCoobbligato(sender: Bottone): void {
        this.state.Dati.RisAPI.Dati.splice(sender.props.Dato, 1);
        this.setState({ Dati: this.state.Dati });
    }

    private ApriPopupCoobbligato(indice: number): void {
        let PopupCoobbligato: Window | null = window.open("/anagrafica/0?Popup=true", "PopupCoobbligato", "width=1920,height=1080");
        let self = this;
        if (PopupCoobbligato != null) {
            PopupCoobbligato.onbeforeunload = function() {
                if (PopupCoobbligato != null) {
                    let PopupID_Anag = PopupCoobbligato.document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                    if (PopupID_Anag != null && PopupID_Anag.value != null) {
                        self.state.Dati.RisAPI.Dati[indice].ID_Anag = Number(PopupID_Anag.value);
                        self.setState({ Dati: self.state.Dati });
                    }
                }
            };
        }
    }

    public render() {
        let infoContesto: Dati.InfoContesto[] = [];
        if (this.ID_FideAffidamento != undefined) {
            infoContesto.push(new Dati.InfoContesto(Trad.Trad("Affidamento"), "/api/fideaffidamento/Contesto?ID_FideAffidamento=" + this.ID_FideAffidamento, ""));
        }
        var caricaDocumenti = <div></div>;
        if (this.ID_FideAffidamento != undefined && this.ID_FideAffidamento > 0) {
            caricaDocumenti = <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                <a href={"/file/" + this.ID_FideAffidamento} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Documenti")} target="_blank">
                    <i className="fa fa-archive"></i>{Trad.Trad("Documenti")}
                </a>
            </div>;
        }

        if (this.ID_Polizza != undefined) {
            infoContesto.push(new Dati.InfoContesto(Trad.Trad("Polizza"), "/api/polizza/Contesto?ID_Polizza=" + this.ID_Polizza, ""));
            caricaDocumenti = <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                <a href={"/file/" + this.ID_Polizza} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Documenti")} target="_blank">
                    <i className="fa fa-archive"></i>{Trad.Trad("Documenti")}
                </a>
            </div>;
        }
        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-users"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Coobbligati")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                <a href="#" onClick={(e) => { e.preventDefault(); this.OnNuovoCoobbligato() }} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>{Trad.Trad("Nuovo")}
                                </a>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className="table-responsive" style={{ overflowX: "visible" }}>
                                <table className="table table-hover dtr-inline dataTable">
                                    <thead>
                                        <tr className="sfondoTab">
                                            <th colSpan={2} className="TextCenter">{Trad.Trad("Coobbligati")}</th>
                                            <th style={{ width: 150 }} className="TextCenter">{Trad.Trad("Quota")}</th>
                                            <th style={{ width: 200 }} className="TextCenter">{Trad.Trad("Importo")}</th>
                                            <th style={{ width: 150 }} className="TextCenter">{Trad.Trad("Azioni")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ChiamaAPI Aggiornare={1} URL={"/api/fidecoobbligato/ricerca?ID_FideAffidamento=" + (this.ID_FideAffidamento || "") + "&ID_Polizza=" + (this.ID_Polizza || "")} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={(s, e) => this.OnErrore(s, e)} />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="kt-portlet__foot kt-portlet__foot--fit">
                            <div className="kt-form login-form__actions kt-form login-form__actions--right">
                                <div className="row">
                                    <div className="col kt-form__actions kt-form__actions--right">
                                        <BottoneAPI Default Testo={Trad.Trad("Salva")} URL="/api/fidecoobbligato/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} />
                                        <button className="btn btn-secondary" onClick={history.back} style={{ marginLeft: 5 }}>{Trad.Trad("Annulla")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FideCoobbligato.tsx